"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _coreBaseProps = require("@vfuk/core-base-props");
var _coreThemes = require("@vfuk/core-themes");
var _coreIcon = _interopRequireDefault(require("@vfuk/core-icon"));
var _coreLoadingSpinner = _interopRequireDefault(require("@vfuk/core-loading-spinner"));
var _Button = _interopRequireDefault(require("./themes/Button.theme"));
var Styled = _interopRequireWildcard(require("./styles/Button.style"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
} /* eslint-disable complexity, sonarjs/cognitive-complexity */
var Button = function Button(_ref) {
  var _React$createElement;
  var _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 'auto' : _ref$width,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$htmlAttributes = _ref.htmlAttributes,
    htmlAttributes = _ref$htmlAttributes === void 0 ? {
      target: undefined,
      type: undefined
    } : _ref$htmlAttributes,
    dataAttributes = _ref.dataAttributes,
    _ref$inverse = _ref.inverse,
    inverse = _ref$inverse === void 0 ? false : _ref$inverse,
    state = _ref.state,
    href = _ref.href,
    id = _ref.id,
    text = _ref.text,
    onClick = _ref.onClick,
    onMouseDown = _ref.onMouseDown,
    onMouseUp = _ref.onMouseUp,
    onTouchStart = _ref.onTouchStart,
    onTouchEnd = _ref.onTouchEnd,
    icon = _ref.icon,
    customRouterProps = _ref.customRouterProps,
    srText = _ref.srText,
    dataSelectorPrefix = _ref.dataSelectorPrefix,
    localTheme = _ref.localTheme;
  var componentName = 'Button';
  var buttonTheme = (0, _coreThemes.useLocalTheme)(componentName, _Button["default"], localTheme);
  var themeAppearance = buttonTheme.appearance[appearance];
  if (inverse) themeAppearance = themeAppearance.inverse;
  var _themeAppearance = themeAppearance,
    inverseIcon = _themeAppearance.inverseIcon,
    loadingSpinnerAppearance = _themeAppearance.loadingSpinnerAppearance,
    iconAppearance = _themeAppearance.iconAppearance;
  var isSelected = state === 'selected';
  var isDisabled = state === 'disabled' || loading;
  var target = htmlAttributes.target,
    type = htmlAttributes.type;
  return /*#__PURE__*/_react["default"].createElement(Styled.Button, (_React$createElement = {
    buttonTheme: buttonTheme,
    label: srText !== null && srText !== void 0 ? srText : text,
    disabled: isDisabled,
    href: !isDisabled ? href : undefined,
    componentName: componentName,
    dataAttributes: dataAttributes,
    onClick: onClick,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp,
    onTouchStart: onTouchStart,
    onTouchEnd: onTouchEnd,
    type: type,
    id: id,
    target: target
  }, _defineProperty(_React$createElement, "onTouchEnd", onTouchEnd), _defineProperty(_React$createElement, "state", state), _defineProperty(_React$createElement, "loading", loading), _defineProperty(_React$createElement, "inverse", inverse), _defineProperty(_React$createElement, "appearance", appearance), _defineProperty(_React$createElement, "width", width), _defineProperty(_React$createElement, "icon", icon), _defineProperty(_React$createElement, "customRouterProps", customRouterProps), _defineProperty(_React$createElement, "dataSelectorPrefix", (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix)), _React$createElement), loading && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Styled.LoadingIcon, null, /*#__PURE__*/_react["default"].createElement(_coreLoadingSpinner["default"], {
    inverse: inverseIcon,
    size: 3,
    appearance: loadingSpinnerAppearance,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'loading')
  })), /*#__PURE__*/_react["default"].createElement(Styled.HiddenText, {
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'hidden-text')
  }, text)), (Boolean(icon) || isSelected) && !loading && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_coreIcon["default"], {
    inverse: inverseIcon,
    size: 3,
    appearance: iconAppearance,
    name: isSelected ? 'tick' : icon.name,
    group: "system",
    isResponsive: false,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "".concat(isSelected ? 'tick' : icon.name))
  }), text), !icon && !isSelected && !loading && text);
};
Button.displayName = "Button";
var _default = Button;
exports["default"] = _default;